import {isAnyOf, Middleware} from '@reduxjs/toolkit'

import {initOrderSheet} from '../../actions'

/** @TODO 추후 범용적인 미들웨어로 리팩토링하여 사용  */
// alert 을 띄워야하는 rejected action
const isPayloadAlertAction = isAnyOf(initOrderSheet.fulfilled)

const alertProcessMiddleware: Middleware = () => (next) => (action) => {
    if (isPayloadAlertAction(action)) {
        const exception = action?.payload?.exception
        if (exception?.fallbackMessage) {
            alert(exception.fallbackMessage)
        }
    }
    next(action)
}

export default alertProcessMiddleware
